(function(){
  function init(root){
    if(root.dataset.suInit) return;
    root.dataset.suInit = '1';
    var code = root.dataset.code || '';
    var behavior = root.dataset.behavior || 'drawer';

    var tile = root.querySelector('[data-su-copy]');
    if(tile){
      var label = tile.querySelector('[data-su-copy-label]');
      var original = label ? label.textContent : '';
      var copy = function(){
        var done = function(){ if(!label) return; label.textContent = root.dataset.copied || 'COPIED!'; setTimeout(function(){ label.textContent = original; }, 2000); };
        try { navigator.clipboard.writeText(code).then(done, done); } catch(e){ done(); }
      };
      tile.addEventListener('click', copy);
      tile.addEventListener('keydown', function(e){ if(e.key === 'Enter' || e.key === ' '){ e.preventDefault(); copy(); } });
    }

    var end = Date.parse(root.dataset.end);
    if(!isNaN(end)){
      var pad = function(n){ return ('0' + n).slice(-2); };
      var d1 = root.querySelector('[data-su-d]'), h1 = root.querySelector('[data-su-h]'), m1 = root.querySelector('[data-su-m]'), s1 = root.querySelector('[data-su-s]'), sh = root.querySelector('[data-su-short]');
      var tick = function(){
        var ms = Math.max(0, end - Date.now());
        var d = Math.floor(ms/864e5); ms -= d*864e5;
        var h = Math.floor(ms/36e5); ms -= h*36e5;
        var m = Math.floor(ms/6e4); ms -= m*6e4;
        var s = Math.floor(ms/1e3);
        if(d1) d1.textContent = d;
        if(h1) h1.textContent = pad(h);
        if(m1) m1.textContent = pad(m);
        if(s1) s1.textContent = pad(s);
        if(sh) sh.textContent = d + 'D ' + pad(h) + 'H ' + pad(m) + 'M ' + pad(s) + 'S LEFT';
      };
      tick(); setInterval(tick, 1000);
    }

    function applyDiscount(){
      if(!code) return Promise.resolve();
      return fetch('/discount/' + encodeURIComponent(code), { method:'GET', credentials:'same-origin' }).catch(function(){});
    }

    // AfterSell already opens its own cart automatically whenever /cart/add.js is called,
    // so this no longer needs to find and open a drawer itself — doing so on top of
    // AfterSell's auto-open caused the cart to appear to open multiple times (same issue
    // fixed in quick-hits-lander.js). Just report whether AfterSell is present so the
    // button can fall back to its own "added!" confirmation state when it isn't.
    function openDrawer(){
      return !!(window.aftersell && window.aftersell.cart);
    }

    Array.prototype.forEach.call(root.querySelectorAll('[data-su-atc]'), function(btn){
      btn.addEventListener('click', function(evt){
        evt.preventDefault();
        var id = btn.getAttribute('data-variant-id');
        if(!id) return;
        var html = btn.innerHTML;
        btn.setAttribute('disabled','');
        btn.textContent = 'adding...';
        applyDiscount().then(function(){
          return fetch('/cart/add.js', {
            method:'POST',
            credentials:'same-origin',
            headers:{'Content-Type':'application/json','Accept':'application/json'},
            body: JSON.stringify({ items:[{ id: Number(id), quantity: 1 }], sections:'cart-drawer,cart-icon-bubble', sections_url: window.location.pathname })
          });
        })
        .then(function(r){ return r.json().then(function(j){ return { ok: r.ok, data: j }; }); })
        .then(function(res){
          btn.innerHTML = html;
          btn.removeAttribute('disabled');
          if(!res.ok){
            btn.textContent = (res.data && res.data.description) ? 'unavailable' : 'try again';
            setTimeout(function(){ btn.innerHTML = html; }, 2500);
            return;
          }
          if(behavior === 'checkout'){ window.location.href = '/checkout'; return; }
          if(behavior === 'cart'){ window.location.href = '/cart'; return; }
          if(!openDrawer(res.data)){
            btn.textContent = root.dataset.added || 'added!';
            setTimeout(function(){ btn.innerHTML = html; }, 2500);
          }
        })
        .catch(function(){ btn.innerHTML = html; btn.removeAttribute('disabled'); });
      });
    });
  }

  function boot(){ Array.prototype.forEach.call(document.querySelectorAll('[data-su-root]'), init); }
  if(document.readyState === 'loading'){ document.addEventListener('DOMContentLoaded', boot); } else { boot(); }
  document.addEventListener('shopify:section:load', boot);
})();
